import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useFeatureFlag } from '@steelbuy/data-access';
import { Feature } from '@steelbuy/ts-shared';
import { CheckoutContextProvider } from '../../components/checkout/CheckoutContext';
import { SearchResultsContextProvider } from '../../components/listing-search/SearchResultsContext';
import { RoutePath } from '../../router/Routes';

export const MyAlertsView = () => {
    const { isFeatureSupported } = useFeatureFlag();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isFeatureSupported(Feature.ALERT)) {
            navigate(RoutePath.MY_LISTINGS);
        }
    }, []);

    return (
        <CheckoutContextProvider>
            <SearchResultsContextProvider>
                <Outlet />
            </SearchResultsContextProvider>
        </CheckoutContextProvider>
    );
};
